import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { TileCard, EmpButton as Button, PageHeader } from '@empowernow/ui';
import PageHeading from '../core/a11y/PageHeading';
import { pagesApi } from '../core/services/api';
import { PreviewMode } from '../components/PreviewMode';
import './PageRunner.css';

export default function PageRunner() {
  const { pageId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery({
    queryKey: ['page', pageId],
    queryFn: () => pagesApi.getPage(pageId!),
    enabled: !!pageId,
  });

  if (isLoading) return (
    <div style={{ padding: '24px' }}>
      <PageHeader title="Page" />
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '100px 0',
        color: 'var(--main-text)'
      }}>
        <div role="status" aria-live="polite">Loading page…</div>
      </div>
    </div>
  );
  
  if (error || !data) return (
    <div style={{ padding: '24px' }}>
      <PageHeader title="Page" />
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '100px 0',
        color: 'var(--main-text)'
      }}>
        <TileCard theme="auto" elevation={1} style={{ maxWidth: '500px', width: '100%' }}>
          <div style={{ padding: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ color: 'var(--error-color)' }}>Failed to load page</div>
            <Button onClick={() => navigate('/pages')}>Back to Pages</Button>
          </div>
        </TileCard>
      </div>
    </div>
  );

  const page = (data as any);
  const pageTitle: string = page?.title || page?.name || 'Page';

  return (
    <div>
      <div className="page-runner-content" style={{ padding: '16px 0' }}>
        <div style={{ 
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden'
        }}>
          <PreviewMode 
            page={page} 
            hideExitButton 
            autoLoadData 
          />
        </div>
      </div>
    </div>
  );
}
